import { Link, Typography } from "@mui/material";
import { useSocialTermsDocuments } from "Components/Social/SocialTermsConsent/useSocialTermsDocuments";
import { Trans } from "react-i18next";
import { Resources, getResourcePath } from "Translations/Resources";

const RESOURCES = Resources.Social.Terms;

type Props = {
  /** "Shrnutí smlouvy" in the text — expands the inline summary below the note. */
  onSummaryRequested: () => void;
};

/**
 * Explanatory paragraph under the consent checkbox: who provides the chat, that it is free, how
 * to terminate or withdraw, the privacy-policy link and a link that expands the contract summary.
 */
export const SocialTermsConsentNote = ({ onSummaryRequested }: Props) => {
  const { privacyPolicy } = useSocialTermsDocuments();

  return (
    <Typography variant="body2" color="text.secondary">
      <Trans
        i18nKey={getResourcePath(RESOURCES.Note)}
        components={{
          privacy: (
            <Link
              href={privacyPolicy.url}
              target="_blank"
              rel="noopener noreferrer"
            />
          ),
          // type="button": the note sits inside the handle <form>, a bare button would submit it.
          summary: (
            <Link
              component="button"
              type="button"
              variant="body2"
              onClick={onSummaryRequested}
              sx={{ verticalAlign: "baseline" }}
            />
          ),
        }}
      />
    </Typography>
  );
};
